/**
 * find customized name of submodules under analysis or insights
 * @param moduleValue: 'insights' | 'analysis'
 * @param submoduleKey
 */
import useCustomizedModuleFinder from './useCustomizedModuleFinder';
import {
  DEFALUT_PERMISSION_SECTION,
  INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS,
  SEGMENTS,
} from '@model';

const SUBMODULE_NAMES = {
  ...INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS,
  ...SEGMENTS,
};

function useSubmoduleName(moduleValue, submoduleKey) {
  const moduleItem = useCustomizedModuleFinder(moduleValue);
  if (moduleItem && moduleItem?.originPermissions?.length) {
    const target = moduleItem?.originPermissions.find(
      (i) => i.value === submoduleKey,
    );
    if (target) {
      return target.label;
    }
  }
  return SUBMODULE_NAMES[submoduleKey];
}

export const findSubModuleName = (moduleKey, customizedModules = []) =>
  customizedModules
    .filter((i) =>
      [
        DEFALUT_PERMISSION_SECTION.INSIGHT,
        DEFALUT_PERMISSION_SECTION.ANALYSIS,
      ].includes(i.value),
    )
    .flatMap((i) => i.originPermissions)
    .find((i) => i.value === moduleKey)?.label;

export default useSubmoduleName;
